// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n\n/** 存放自定义的变量，可全局直接使用 */\n\n/** 主题色 */\n\n/** 字体样式 */\n.empty {\n  text-align: center;\n  font-size: 0.083333rem;\n  color: #777777;\n}\n.Paginationview {\n  width: 100%;\n  text-align: right;\n  background-color: #fff;\n  padding: 0.078125rem 0;\n  box-sizing: border-box;\n}", ""]);
// Exports
module.exports = exports;
